import React from "react";
import { Card } from "react-bootstrap";
import { Bar } from "react-chartjs-2";

const ThreadsHealth = ({ health }) => {
  if (!health) return null;

  const threadCount = health?.threadCount ?? 0;
  const peakThreadCount = health?.peakThreadCount ?? 0;
  const daemonThreadCount = health?.daemonThreadCount ?? 0;

  const data = {
    labels: ["Current", "Peak", "Daemon"],
    datasets: [
      {
        label: "Threads",
        data: [threadCount, peakThreadCount, daemonThreadCount],
        backgroundColor: ["#36A2EB", "#FF6384", "#FFCE56"],
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value =
              typeof context.raw === "number"
                ? context.raw
                : Number(context.raw);
            return `${context.label}: ${value.toLocaleString()}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0, // no decimals
        },
      },
    },
  };

  return (
    <Card className="flex-fill w-100">
      <Card.Header>
        <Card.Title>Threads</Card.Title>
      </Card.Header>
      <Card.Body className="d-flex justify-content-center align-items-center flex-column">
        <div style={{ width: "300px" }}>
          <Bar data={data} options={options} />
        </div>
        <div className="mt-3 text-center">
          <h5>{threadCount.toLocaleString()}</h5>
          <small>
            Current Threads | Peak: {peakThreadCount.toLocaleString()} | Daemon:{" "}
            {daemonThreadCount.toLocaleString()}
          </small>
        </div>
      </Card.Body>
      <Card.Footer>
        <small className="d-flex">
          Status:{" "}
          <div
            className={`ms-2 me-2 circle ${
              health.status === "UP"
                ? "pulse green"
                : health.status === "DOWN"
                ? "red"
                : "blue"
            }`}
          ></div>
        </small>
      </Card.Footer>
    </Card>
  );
};

export default ThreadsHealth;
